/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: inventory.fga
 * Run: pnpm run gen:permissions -- inventory
 */

import type { ModulePermissions } from './types';

export const inventoryPermissions = {
  module: 'inventory',
  displayName: 'Inventory',
  entities: [
    {
      name: 'category',
      displayName: 'Category',
      permissions: [
        { key: 'categoryRead', action: 'Read', category: 'crud' },
        { key: 'categoryCreate', action: 'Create', category: 'crud' },
        { key: 'categoryUpdate', action: 'Update', category: 'crud' },
        { key: 'categoryDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'cycleCountLine',
      displayName: 'Cycle Count Line',
      permissions: [
        { key: 'cycleCountLineRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'cycleCountSchedule',
      displayName: 'Cycle Count Schedule',
      permissions: [
        { key: 'cycleCountScheduleRead', action: 'Read', category: 'crud' },
        { key: 'cycleCountScheduleCreate', action: 'Create', category: 'crud' },
        { key: 'cycleCountScheduleUpdate', action: 'Update', category: 'crud' },
        { key: 'cycleCountScheduleDelete', action: 'Delete', category: 'crud' },
        {
          key: 'cycleCountScheduleActivate',
          action: 'Activate',
          category: 'custom',
        },
        {
          key: 'cycleCountScheduleDeactivate',
          action: 'Deactivate',
          category: 'custom',
        },
      ],
    },
    {
      name: 'cycleCountTask',
      displayName: 'Cycle Count Task',
      permissions: [
        { key: 'cycleCountTaskRead', action: 'Read', category: 'crud' },
        { key: 'cycleCountTaskCreate', action: 'Create', category: 'crud' },
        { key: 'cycleCountTaskUpdate', action: 'Update', category: 'crud' },
        { key: 'cycleCountTaskDelete', action: 'Delete', category: 'crud' },
        { key: 'cycleCountTaskApprove', action: 'Approve', category: 'custom' },
        { key: 'cycleCountTaskCancel', action: 'Cancel', category: 'custom' },
        {
          key: 'cycleCountTaskComplete',
          action: 'Complete',
          category: 'custom',
        },
        { key: 'cycleCountTaskFreeze', action: 'Freeze', category: 'custom' },
        { key: 'cycleCountTaskStart', action: 'Start', category: 'custom' },
        {
          key: 'cycleCountTaskUnfreeze',
          action: 'Unfreeze',
          category: 'custom',
        },
      ],
    },
    {
      name: 'inventoryAccount',
      displayName: 'Inventory Account',
      permissions: [
        { key: 'inventoryAccountRead', action: 'Read', category: 'crud' },
        { key: 'inventoryAccountCreate', action: 'Create', category: 'crud' },
        { key: 'inventoryAccountUpdate', action: 'Update', category: 'crud' },
        { key: 'inventoryAccountDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'inventoryBalance',
      displayName: 'Inventory Balance',
      permissions: [
        { key: 'inventoryBalanceRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'inventoryFacilitySettings',
      displayName: 'Inventory Facility Settings',
      permissions: [
        {
          key: 'inventoryFacilitySettingsRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'inventoryFacilitySettingsUpdate',
          action: 'Update',
          category: 'crud',
        },
      ],
    },
    {
      name: 'inventoryLot',
      displayName: 'Inventory Lot',
      permissions: [
        { key: 'inventoryLotRead', action: 'Read', category: 'crud' },
        { key: 'inventoryLotCreate', action: 'Create', category: 'crud' },
        { key: 'inventoryLotUpdate', action: 'Update', category: 'crud' },
        { key: 'inventoryLotDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'inventoryMovement',
      displayName: 'Inventory Movement',
      permissions: [
        { key: 'inventoryMovementRead', action: 'Read', category: 'crud' },
        { key: 'inventoryMovementCreate', action: 'Create', category: 'crud' },
        { key: 'inventoryMovementUpdate', action: 'Update', category: 'crud' },
        { key: 'inventoryMovementDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'inventoryPeriod',
      displayName: 'Inventory Period',
      permissions: [
        { key: 'inventoryPeriodRead', action: 'Read', category: 'crud' },
        { key: 'inventoryPeriodCreate', action: 'Create', category: 'crud' },
        { key: 'inventoryPeriodUpdate', action: 'Update', category: 'crud' },
        { key: 'inventoryPeriodDelete', action: 'Delete', category: 'crud' },
        {
          key: 'inventoryPeriodArchive',
          action: 'Archive',
          category: 'custom',
        },
        { key: 'inventoryPeriodClose', action: 'Close', category: 'custom' },
        { key: 'inventoryPeriodLock', action: 'Lock', category: 'custom' },
        { key: 'inventoryPeriodUnlock', action: 'Unlock', category: 'custom' },
      ],
    },
    {
      name: 'inventoryPeriodBalance',
      displayName: 'Inventory Period Balance',
      permissions: [
        { key: 'inventoryPeriodBalanceRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'inventoryPeriodConfig',
      displayName: 'Inventory Period Config',
      permissions: [
        { key: 'inventoryPeriodConfigRead', action: 'Read', category: 'crud' },
        {
          key: 'inventoryPeriodConfigCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'inventoryPeriodConfigUpdate',
          action: 'Update',
          category: 'crud',
        },
      ],
    },
    {
      name: 'inventoryTag',
      displayName: 'Inventory Tag',
      permissions: [
        { key: 'inventoryTagRead', action: 'Read', category: 'crud' },
        { key: 'inventoryTagCreate', action: 'Create', category: 'crud' },
        { key: 'inventoryTagUpdate', action: 'Update', category: 'crud' },
        { key: 'inventoryTagDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'inventoryZone',
      displayName: 'Inventory Zone',
      permissions: [
        { key: 'inventoryZoneRead', action: 'Read', category: 'crud' },
        { key: 'inventoryZoneCreate', action: 'Create', category: 'crud' },
        { key: 'inventoryZoneUpdate', action: 'Update', category: 'crud' },
        { key: 'inventoryZoneDelete', action: 'Delete', category: 'crud' },
        { key: 'inventoryZoneArchive', action: 'Archive', category: 'custom' },
      ],
    },
    {
      name: 'item',
      displayName: 'Item',
      permissions: [
        { key: 'itemRead', action: 'Read', category: 'crud' },
        { key: 'itemCreate', action: 'Create', category: 'crud' },
        { key: 'itemUpdate', action: 'Update', category: 'crud' },
        { key: 'itemDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'itemGroup',
      displayName: 'Item Group',
      permissions: [
        { key: 'itemGroupRead', action: 'Read', category: 'crud' },
        { key: 'itemGroupCreate', action: 'Create', category: 'crud' },
        { key: 'itemGroupUpdate', action: 'Update', category: 'crud' },
        { key: 'itemGroupDelete', action: 'Delete', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Inventory module
 */
export type InventoryPermissionKey =
  | 'categoryRead'
  | 'categoryCreate'
  | 'categoryUpdate'
  | 'categoryDelete'
  | 'cycleCountLineRead'
  | 'cycleCountScheduleRead'
  | 'cycleCountScheduleCreate'
  | 'cycleCountScheduleUpdate'
  | 'cycleCountScheduleDelete'
  | 'cycleCountScheduleActivate'
  | 'cycleCountScheduleDeactivate'
  | 'cycleCountTaskRead'
  | 'cycleCountTaskCreate'
  | 'cycleCountTaskUpdate'
  | 'cycleCountTaskDelete'
  | 'cycleCountTaskApprove'
  | 'cycleCountTaskCancel'
  | 'cycleCountTaskComplete'
  | 'cycleCountTaskFreeze'
  | 'cycleCountTaskStart'
  | 'cycleCountTaskUnfreeze'
  | 'inventoryAccountRead'
  | 'inventoryAccountCreate'
  | 'inventoryAccountUpdate'
  | 'inventoryAccountDelete'
  | 'inventoryBalanceRead'
  | 'inventoryFacilitySettingsRead'
  | 'inventoryFacilitySettingsUpdate'
  | 'inventoryLotRead'
  | 'inventoryLotCreate'
  | 'inventoryLotUpdate'
  | 'inventoryLotDelete'
  | 'inventoryMovementRead'
  | 'inventoryMovementCreate'
  | 'inventoryMovementUpdate'
  | 'inventoryMovementDelete'
  | 'inventoryPeriodRead'
  | 'inventoryPeriodCreate'
  | 'inventoryPeriodUpdate'
  | 'inventoryPeriodDelete'
  | 'inventoryPeriodArchive'
  | 'inventoryPeriodClose'
  | 'inventoryPeriodLock'
  | 'inventoryPeriodUnlock'
  | 'inventoryPeriodBalanceRead'
  | 'inventoryPeriodConfigRead'
  | 'inventoryPeriodConfigCreate'
  | 'inventoryPeriodConfigUpdate'
  | 'inventoryTagRead'
  | 'inventoryTagCreate'
  | 'inventoryTagUpdate'
  | 'inventoryTagDelete'
  | 'inventoryZoneRead'
  | 'inventoryZoneCreate'
  | 'inventoryZoneUpdate'
  | 'inventoryZoneDelete'
  | 'inventoryZoneArchive'
  | 'itemRead'
  | 'itemCreate'
  | 'itemUpdate'
  | 'itemDelete'
  | 'itemGroupRead'
  | 'itemGroupCreate'
  | 'itemGroupUpdate'
  | 'itemGroupDelete';
